import template from './region.html';
import controller from './region.controller';
import './region.scss';

let regionComponent = {
  bindings: {},
  template,
  controller
};

export default regionComponent;



// WEBPACK FOOTER //
// ./client/app/components/region/region.component.js